import { offsetDateToTimezone } from '@assess/shared/entities';

import { dateFormatDefaultWithTimeAt } from '../constants/date-formats';
import { FormatDatePipe } from '../pipes/format-date.pipe';

const formatDate = new FormatDatePipe();

export function transformDateToTimezone(date: string | Date, timezone: any) {
  const dateObj = offsetDateToTimezone(date, timezone);

  return formatDate.transform(dateObj, dateFormatDefaultWithTimeAt);
}
